import React from "react";
import ConversionPage from "@/components/ConversionPage";

export default function HomeGymAcceleratorPage() {
  return (
    <ConversionPage
      accentColor="emerald"
      badge="Accelerator  |  Home Gym"
      headline={<>YOU BUILT THE GYM.<br /><span className="text-emerald-400">NOW BUILD THE PROGRAM.</span></>}
      subheadline="Most home gym owners have the tools but not the plan. You've got the rack, the barbell, the dumbbells — but you're still piecing together random workouts from the internet. The Home Gym Accelerator gives you 2-6 structured sessions per week depending on your goals — the same science we use with competitive athletes, designed specifically for your setup."
      heroImage="https://images.unsplash.com/photo-1627257058769-0a99529e4312?auto=format&fit=crop&w=1920&q=80"
      painPoints={[
        "You spent $3K+ on equipment that's collecting dust because you don't have a real program.",
        "You've been doing the same bench-squat-deadlift routine for months and stopped seeing results.",
        "You know you should be training smarter but you don't have time to research programming theory.",
      ]}
      featureTitle="What's Inside the Home Gym Accelerator"
      features={[
        { title: "Periodized Programming", desc: "Not random workouts. A structured system that cycles through strength, hypertrophy, and power phases." },
        { title: "Built for Your Equipment", desc: "Every program is designed around a rack, barbell, dumbbells, and bench. No machines required." },
        { title: "2-6 Sessions Per Week", desc: "You choose the volume. Whether it's 2 focused days or 6 full sessions — the program scales to your schedule." },
        { title: "Auto-Progression Engine", desc: "The system tracks your lifts and tells you exactly when to increase weight. No guesswork." },
        { title: "In-Depth Nutritional Guidance", desc: "Macro targets and meal guidance tailored to your goals — whether it's performance, body comp, or both." },
        { title: "Exercise Video Library", desc: "Coaching cues for every movement so you train with confidence, even alone." },
        { title: "New Blocks Every 4-6 Weeks", desc: "Fresh programming that keeps your body adapting and your mind engaged." },
        { title: "AI Coach Access", desc: "Ask questions, get form tips, and adjust your training on the fly with 24/7 AI coaching." },
      ]}
      testimonial={{
        quote: "Having elite programming in my garage changed everything. I'm stronger at 38 than I was at 25.",
        name: "Home Gym Athlete",
        detail: "Accelerator member since launch",
      }}
      price="$40"
      priceInterval="week"
      priceCta="Start the Accelerator"
      priceTier="accelerator"
      faqs={[
        { q: "What equipment do I need?", a: "A squat rack or power rack, barbell with weight plates, dumbbells (adjustable or fixed), a flat/incline bench, and a pull-up bar. Resistance bands are helpful but optional." },
        { q: "I've been training for years. Is this too basic?", a: "No. The Accelerator is built for experienced lifters who want structure. The programming is periodized and progressive — it meets you at your level and pushes you forward." },
        { q: "How is this different from Foundations?", a: "Foundations teaches you the basics. The Accelerator assumes you have them. It's more advanced programming with periodization, nutritional guidance, and AI coaching." },
        { q: "Can I switch from Foundations to this?", a: "Yes. You can upgrade anytime from your athlete dashboard. Your Foundations subscription will be cancelled and replaced with the Accelerator." },
      ]}
      backPath="/"
    />
  );
}
